var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"whatsapp-float",attrs:{"fab":"","large":"","color":"green","href":_vm.whatsappLink,"target":"_blank"}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-whatsapp")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }